// ============================================================================
// PROPERTY ENDPOINTS
// ============================================================================
// Endpoint definitions for Property Master module

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

/**
 * Base path for property endpoints (matches PropertyController route)
 */
const BASE_PATH = '/Property';

/**
 * Property Endpoints
 */
export const propertyEndpoints = {
  /**
   * Get all properties (paginated)
   * GET /Property
   */
  list: () => buildEndpoint(BASE_PATH),

  /**
   * Get property by ID
   * GET /Property/:id
   */
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Get property by code
   * GET /Property/code/:code
   */
  getByCode: (code: string) => buildEndpointWithParams(`${BASE_PATH}/code/:code`, { code }),

  /**
   * Create new property
   * POST /Property
   */
  create: () => buildEndpoint(BASE_PATH),

  /**
   * Update property
   * PUT /Property/:id
   */
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Delete property
   * DELETE /Property/:id
   */
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Validate property code uniqueness
   * GET /Property/validate/code/:code?excludeId=
   */
  validateCode: (code: string) =>
    buildEndpointWithParams(`${BASE_PATH}/validate/code/:code`, { code }),

  /**
   * Validate property name uniqueness
   * GET /Property/validate/name/:name?excludeId=
   */
  validateName: (name: string) =>
    buildEndpointWithParams(`${BASE_PATH}/validate/name/:name`, { name }),
} as const;

/**
 * Export endpoints
 */
export default propertyEndpoints;
